export default "__VITE_ASSET__60b9cafb__"